import { Editor as TinyMCE, IAllProps } from "@tinymce/tinymce-react";
import React from "react";
import * as config from "./initialConfig";

interface MenuOptions {
	title: string;
	items: string;
}
type Menus = "file" | "edit" | "view" | "insert" | "format" | "tools" | "table" | "help";
type MenuType = Partial<Record<Menus, MenuOptions>>;
type EventHandler<A> = (a: A, editor?: any) => any;

export interface EditorProps extends IAllProps {
	init?: Record<string, any>;
	initialValue?: string;
	innerRef?: any;
	menu?: MenuType;
	onEditorChange: EventHandler<any>;
	placeholder?: string;
}

class Editor extends React.Component<EditorProps> {
	static PLUGIN_LIST = config.PLUGIN_LIST;
	static TOOLBAR = config.TOOLBAR;

	render() {
		const { init, placeholder, ...otherProps } = this.props;
		return (
			<TinyMCE
				tinymceScriptSrc="https://cdnjs.cloudflare.com/ajax/libs/tinymce/5.10.9/tinymce.min.js"
				init={
					init || placeholder
						? Object.assign({}, config.defaultConfig, { placeholder })
						: config.defaultConfig
				}
				{...otherProps}
			/>
		);
	}
}

export default Editor;
